import { CssType, ThemeType } from 'src/theme/jss-types';
import { refreshButton } from 'src/theme/cssSnippets/commonSnippets';
import { MIN_WIDTH } from 'src/globals';

export const TmsCarrierReceivablesStyles = (theme: ThemeType): CssType => ({
  mainDiv: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#f5f4f2',
    minHeight: 'calc(100vh - 48px)',
    '& .ant-checkbox-inner': {
      width: '16px',
      height: '16px',
      borderRadius: '2px',
      border: '1px solid #999999',
    },
    '& .anticon-down': {
      fontSize: '12px',
    },
    '& .ant-btn.ant-dropdown-trigger': {
      borderColor: theme.primaryColor,
      color: theme.primaryColor,
    },
    minWidth: MIN_WIDTH,
  },
  tabsOuterWrapper: {
    margin: '8px 8px 0 8px',
  },
  customTabsContainer: {
    backgroundColor: '#fff',
    height: '48px',
    borderRadius: '2px',
    boxShadow: '1px 1px 3px 0px rgba(0,0,0,0.1)',
    display: 'flex',
    margin: '8px',
    marginBottom: 0,
  },
  bucketTab: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 24px',
    height: '48px',
    backgroundColor: '#fff',
    cursor: 'pointer',
    position: 'relative',
    transition: 'all 0.3s ease',
    borderBottom: '4px solid transparent',
  },
  bucketTabActive: {
    borderBottom: '4px solid #4abfe5',
  },
  bucketTabText: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 400,
    color: '#8c8c8c',
    margin: 0,
    whiteSpace: 'nowrap',
  },
  bucketTabTextActive: {
    fontWeight: 600,
    color: '#1659cb',
  },
  tabContentContainer: {
    backgroundColor: '#fff',
    margin: '0 8px 8px 8px',
    borderRadius: '0 0 2px 2px',
  },
  bucketTabs: {
    '& .ant-tabs-nav': {
      margin: 0,
      padding: '0',
    },
    '& .ant-tabs-tab': {
      padding: '10px 24px',
      fontSize: '12px',
      fontWeight: 400,
      color: '#8c8c8c',
      backgroundColor: '#fff',
      border: 'none',
      borderBottom: '4px solid transparent',
      margin: 0,
      '&:hover': {
        color: theme.primaryColor,
      },
    },
    '& .ant-tabs-tab-active': {
      color: `${theme.primaryColor} !important`,
      fontWeight: 600,
      borderBottom: `4px solid ${theme.primaryColor} !important`,
    },
    '& .ant-tabs-content-holder': {
      padding: 0,
    },
  },
  tabPane: {
    backgroundColor: '#fff',
  },
  filterContainer: {
    backgroundColor: '#fff',
    height: '48px',
    borderBottom: '1px solid #e8e8e8',
    borderRadius: '2px 2px 0 0',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '0 24px',
    boxShadow: '1px 1px 3px 0px rgba(0,0,0,0.1)',
    marginTop: '8px',
  },
  dateRangePicker: {
    height: '32px',
    border: '1px solid #999999',
    borderRadius: '0px 4px 4px 0px',
    fontSize: '12px',
    fontWeight: 600,
    backgroundColor: '#fff',
    '& .ant-picker-input': {
      backgroundColor: '#fff !important',
    },
    '& .ant-picker-input > input': {
      fontSize: '12px !important',
      fontWeight: '600 !important',
      fontFamily: "'Open Sans', sans-serif !important",
      color: '#111111 !important',
      backgroundColor: '#fff !important',
    },
    '& .ant-picker-range-separator': {
      color: '#111111 !important',
      fontWeight: '600 !important',
    },
    '& .ant-picker-suffix': {
      color: '#999999 !important',
    },
  },
  select: {
    minWidth: '120px',
    fontSize: '12px',
    height: '32px',
    '&.ant-select:not(.ant-select-customize-input) .ant-select-selector': {
      border: '1px solid #999999 !important',
      borderRight: 'none !important',
      borderRadius: '4px 0px 0px 4px !important',
      height: '32px !important',
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      backgroundColor: '#fafafa !important',
    },
    '& .ant-select-selection-placeholder': {
      color: '#cccccc !important',
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
    },
    '& .ant-select-selection-item': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      color: '#111111 !important',
      backgroundColor: '#fafafa !important',
    },
    '& .ant-select-arrow': {
      color: '#999999 !important',
    },
  },
  filterLabel: {
    backgroundColor: '#fafafa',
    border: '1px solid #999999',
    borderRight: 'none',
    borderRadius: '4px 0 0 4px',
    padding: '4px 8px',
    height: '32px',
    display: 'flex',
    alignItems: 'center',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px',
    fontWeight: 600,
    color: '#111111',
    whiteSpace: 'nowrap',
  },
  selectWrapper: {
    position: 'relative',
    flex: 1,
    minWidth: 0,
  },
  filterSelect: {
    minWidth: '120px',
    fontSize: '12px',
    height: '32px',
    '&.ant-select:not(.ant-select-customize-input) .ant-select-selector': {
      border: '1px solid #999999 !important',
      borderRadius: '0px 4px 4px 0px !important',
      height: '32px !important',
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      backgroundColor: '#fff !important',
    },
    '& .ant-select-selection-placeholder': {
      color: '#cccccc !important',
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
    },
    '& .ant-select-selection-item': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      color: '#111111 !important',
      backgroundColor: '#fff !important',
    },
    '& .ant-select-arrow': {
      color: '#999999 !important',
    },
  },
  input: {
    width: '200px',
    height: '32px',
    fontSize: '12px',
    border: '1px solid #999999 !important',
    borderRadius: '0px 4px 4px 0px !important',
    '& input': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      color: '#111111 !important',
      backgroundColor: '#fff !important',
    },
    '& input::placeholder': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
    },
    '&.ant-input-affix-wrapper-disabled': {
      backgroundColor: 'transparent !important',
    },
  },
  singleInput: {
    width: '200px',
    height: '32px',
    fontSize: '12px',
    '& input': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      color: '#111111 !important',
      backgroundColor: '#fff !important',
    },
    '& input::placeholder': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
    },
  },
  timeFilterWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: '16px',
  },
  datePickerWrapper: {
    position: 'relative',
  },
  filterInput: {
    width: '200px',
    height: '32px',
    fontSize: '12px',
    '& input': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
      color: '#111111 !important',
      backgroundColor: '#fff !important',
    },
    '& input::placeholder': {
      fontSize: '12px !important',
      fontFamily: "'Open Sans', sans-serif !important",
      fontWeight: '600 !important',
    },
  },
  viewSwitcher: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 24px 0 24px',
    backgroundColor: '#fff',
  },
  actionBar: {
    display: 'flex',
    justifyContent: 'end',
    alignItems: 'center',
    gap: '8px',
    padding: '12px 24px',
    backgroundColor: '#fff',
    borderRadius: '0 0 2px 2px',
    boxShadow: '1px 1px 3px 0px rgba(0,0,0,0.1)',
    height: '48px',
  },
  paginationButton: {
    width: '14px !important',
    height: '14px !important',
    minWidth: '14px !important',
    padding: '0 !important',
    border: 'none !important',
    background: 'transparent !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    boxShadow: 'none !important',
  },
  pageNumber: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '10px',
    fontWeight: 600,
    color: '#111111',
    lineHeight: '12px',
    padding: '0 6px',
  },
  perPageSelect: {
    height: '24px',
    minWidth: '90px',
    fontSize: '10px',
    '& .ant-select-selector': {
      height: '24px !important',
      borderRadius: '4px !important',
      border: '1px solid #999999 !important',
      backgroundColor: '#fff !important',
      padding: '6px !important',
      display: 'flex',
      alignItems: 'center',
    },
    '& .ant-select-selection-item': {
      fontFamily: "'Open Sans', sans-serif !important",
      fontSize: '10px !important',
      fontWeight: '600 !important',
      color: '#111111 !important',
      lineHeight: '12px !important',
    },
    '& .ant-select-arrow': {
      fontSize: '10px !important',
      color: '#999999 !important',
    },
  },
  iconButton: {
    width: '32px !important',
    height: '32px !important',
    minWidth: '32px !important',
    padding: '5px 12px !important',
    border: '1px solid #1659cb !important',
    borderRadius: '4px !important',
    background:
      'linear-gradient(90deg, rgba(22, 89, 203, 0.03) 0%, rgba(22, 89, 203, 0.03) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%) !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#1659cb !important',
    boxShadow: 'none !important',
  },
  sendForReviewButton: {
    height: '32px !important',
    padding: '5px 12px !important',
    border: '1px solid #1659cb !important',
    borderRadius: '4px !important',
    background:
      'linear-gradient(90deg, rgba(22, 89, 203, 0.03) 0%, rgba(22, 89, 203, 0.03) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%) !important',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px !important',
    fontWeight: 600,
    color: '#1659cb !important',
    cursor: 'pointer',
    boxShadow: 'none !important',
    '&:disabled': {
      border: '1px solid #d9d9d9 !important',
      background: '#f5f5f5 !important',
      color: 'rgba(0, 0, 0, 0.25) !important',
      cursor: 'not-allowed',
      opacity: 0.6,
    },
  },
  addChargeButton: {
    height: '32px !important',
    padding: '5px 12px !important',
    border: 'none !important',
    borderRadius: '4px !important',
    backgroundColor: '#1659cb !important',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px !important',
    fontWeight: 600,
    color: '#fff !important',
    cursor: 'pointer',
    boxShadow: 'none !important',
  },
  actionButton: {
    width: '28px !important',
    height: '28px !important',
    minWidth: '28px !important',
    padding: '5px 12px !important',
    border: '1px solid #1659cb !important',
    borderRadius: '4px !important',
    background: 'rgba(22, 89, 203, 0.03) !important',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#1659cb !important',
    fontSize: '14px',
    boxShadow: 'none !important',
  },
  tableWrapper: {
    backgroundColor: '#fff',
    '& .ant-table': {
      fontSize: '12px',
      border: 'none',
    },
    '& .ant-table-thead > tr > th': {
      backgroundColor: '#f2f7fc !important',
      color: '#333333 !important',
      fontWeight: '400 !important',
      fontSize: '12px !important',
      padding: '7px 12px !important',
      borderRight: '0.5px solid #dddddd !important',
      borderBottom: '0.5px solid #dddddd !important',
      height: '36px !important',
      lineHeight: 'normal !important',
    },
    '& .ant-table-thead > tr > th:first-child': {
      borderTopLeftRadius: '4px !important',
    },
    '& .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before': {
      backgroundColor: 'unset',
    },
    '& .ant-table-tbody > tr > td': {
      padding: '10px 12px !important',
      fontSize: '12px !important',
      borderRight: '0.5px solid #dddddd !important',
      borderBottom: '0.5px solid #dddddd !important',
      height: '48px !important',
      backgroundColor: '#fff !important',
    },
    '& .ant-table-tbody > tr:hover > td': {
      backgroundColor: '#fafafa !important',
    },
    '& .ant-table-cell': {
      borderRight: '0.5px solid #dddddd !important',
    },
  },
  table: {
    '& .ant-table-pagination.ant-pagination': {
      display: 'none',
    },
    '& .ant-table-measure-row, & .ant-table-row-hidden': {
      display: 'none !important',
    },
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'flex-end',
    margin: '5px',
  },
  selectWithoutBorder: {
    margin: '0 5px',
  },
  refreshButton: {
    ...refreshButton({ color: theme.primaryColor }),
    marginTop: 0,
    marginLeft: 4,
  },
  ellipsisIcon: {
    fontSize: '16px',
  },
  drawerTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  titleHeading: {
    fontSize: '15px',
  },
  menuItem: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '12px',
    padding: '8px 16px',
  },
  actionsMenu: {
    borderRadius: '4px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
  },
  statusBadge: {
    padding: '1px 7px',
    borderRadius: '10px',
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    display: 'inline-block',
    textAlign: 'center',
  },
  flexRowCenter: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  flexRowEndAlign: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  viewButton: {
    height: '24px',
    padding: '0px 7px',
    border: '1px solid #1659cb',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: '#1659cb',
    fontSize: '12px',
  },
  entityReferenceLink: {
    color: '#1659cb',
    fontWeight: 600,
    fontSize: '12px',
    textDecoration: 'none',
    cursor: 'pointer',
  },
  textAlignRight: {
    textAlign: 'right',
    display: 'block',
  },
  infoIcon: {
    color: '#1659cb',
    fontSize: '10px',
    cursor: 'pointer',
  },
  rejectionInfoIcon: {
    color: '#1659cb',
    fontSize: '12px',
    cursor: 'pointer',
  },
  updaterCell: {
    maxHeight: '48px',
    overflowY: 'scroll',
    overflowX: 'scroll',
  },
  updaterName: {
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
  },
  updaterCode: {
    fontSize: '12px',
    color: '#666666',
    whiteSpace: 'nowrap',
  },
  employeeCode: {
    color: 'gray',
    fontSize: '0.9em',
  },
  tooltipTitle: {
    fontWeight: 600,
    marginBottom: '4px',
  },
  modalHeader: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '18px',
    fontWeight: 600,
    color: '#111111',
    marginBottom: '16px',
    lineHeight: '24px',
  },
  modalWarningIcon: {
    fontSize: '20px',
    color: '#faad14',
    marginTop: '2px',
    marginRight: '8px',
  },
  modalContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    marginBottom: '32px',
    paddingLeft: '32px',
  },
  modalDescription: {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 400,
    color: '#666666',
    lineHeight: '20px',
    flex: 1,
  },
  modalFooter: {
    display: 'flex',
    gap: '12px',
    justifyContent: 'flex-end',
  },
  modalCancelButton: {
    display: 'flex',
    alignItems: 'center',
    height: '40px',
    padding: '10px 24px',
    borderRadius: '4px',
    border: '1px solid #d9d9d9',
    backgroundColor: '#fff',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#595959',
    boxShadow: '0 2px 0 rgba(0, 0, 0, 0.016)',
  },
  modalConfirmButton: {
    height: '40px',
    padding: '10px 24px',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: '#1659cb',
    fontFamily: "'Open Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#fff',
    boxShadow: '0 2px 0 rgba(0, 0, 0, 0.043)',
  },
  validationModalHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  validationDescription: {
    marginBottom: '16px',
    color: '#595959',
    fontSize: '14px',
  },
  bulkUploadInfoBox: {
    marginTop: '16px',
    padding: '12px',
    backgroundColor: '#f0f7ff',
    borderRadius: '4px',
    fontSize: '14px',
    color: '#262626',
  },
});
